module.exports = __webpack_public_path__ + "img/healing.34889013.svg";